import "./NavBar.css";
import { isNeGDDeployment, trackEvent } from "../../../Actions/Utils";
import { navTitle } from "../../../NewConstants/NavConstants";

const NavBar = ({ setStartTour, selectedLanguage, textSize, toggleMenu = () => {}, toggleHelp = () => {}, showTooltipChecklist, setShowTooltipChecklist }) => {
  const handleFeedbackClick = () => {
    toggleHelp();
    trackEvent("Feedback/Support", "Click", "Open Feedback/Support Icon (NavBar)");
  };
  const handletoggleMene = () => {
    toggleMenu();
    trackEvent("Hamburger", "Click", "Open Side Menu");
  };
  const handleStartTour = () => {
    setShowTooltipChecklist(true);
  };
  return (
    <div className="flex justify-between items-center pt-2 px-4 z-0 navBarDiv" style={{backgroundImage:  isNeGDDeployment() ? "url(/Assets/Images/NavBackground.svg)" : "none", height: isNeGDDeployment() ? "3.75rem" : "auto"}}>
      <div onClick={handletoggleMene}>
        <img src={isNeGDDeployment() ? "/Assets/Images/NavBar_White.svg" : "/Assets/Images/NavBar.svg"} alt="Navbar" />
      </div>
      <div className={`font-semibold flex items-center justify-center gap-2.5 py-4 nameBarDiv`} style={{fontSize: `${textSize}rem`}}>
        {isNeGDDeployment() ? "" : navTitle[selectedLanguage]}
      </div>
      <div onClick={handleStartTour} id="tour-help-circle">
        <img src={"/Assets/Images/helpCircle.svg"} alt="Help" />
      </div>
    </div>
  );
};

export default NavBar;
